import React from 'react';

import DisabledPaymentMethod from 'apps/auth/components/common/paymentMethod/DisabledPaymentMethod';
import EnabledPaymentMethod from 'apps/auth/components/common/paymentMethod/EnabledPaymentMethod';
import { PAYMENT_ACH, PAYMENT_BONUS, PAYMENT_OFAKIM } from 'apps/auth/constants/Constants';
import { AMOUNT_FROM } from 'apps/auth/constants/fieldsName';
import { useExtra, useForm } from 'apps/auth/hooks/selectors';
import { GTPaymentMethodService } from 'apps/auth/services/GTPaymentMethodService';

const PaymentMethod = (props) => {
    const { canShowAmlLevelUpgrade = false } = props;
    const { show_modal_kyc_increase_limit, ofakimHandleKycFlow } = useExtra();
    const { fields } = useForm(props.formName);
    const amountFrom = fields[AMOUNT_FROM].value;

    const fromRestriction = props.paymentMethod?.commission?.restrictionFrom;
    const isTemporarilyUnavailableSource = props.paymentMethod?.temporarilyUnavailableSource;
    const temporarilyUnavailableReason = props.paymentMethod?.temporarilyUnavailableReason;
    const method = props.paymentMethod?.method;

    const bonusBalance = method === PAYMENT_BONUS ? props.paymentMethod?.balance : null;
    const fromAmountIssue = GTPaymentMethodService.getIssueType(
        amountFrom,
        fromRestriction?.minAmount,
        fromRestriction?.maxAmount,
        fromRestriction?.multiple,
        bonusBalance,
    );
    const isDisableForACHMethod = method === PAYMENT_ACH && canShowAmlLevelUpgrade;

    const isDisabledForOfakim = show_modal_kyc_increase_limit;

    const getPaymentMethodName = (paymentMethod, category, isProd) => {
        if (isProd) {
            return paymentMethod?.name;
        }

        return `[${paymentMethod?.method}] [${category}]  ${paymentMethod?.name}`;
    };

    if (
        (fromAmountIssue && method !== PAYMENT_ACH && method !== PAYMENT_OFAKIM) ||
        isDisableForACHMethod ||
        isTemporarilyUnavailableSource ||
        isDisabledForOfakim
    ) {
        return (
            <DisabledPaymentMethod
                formName={props.formName}
                name={props.paymentMethod?.name}
                paymentMethod={props.paymentMethod}
                description={props.paymentMethod?.description}
                method={method}
                code={props.paymentMethod?.code}
                icon={props.icon}
                src={props.src}
                diskVariant={props.diskVariant}
                withoutRadius={props.withoutRadius}
                mobilePayAlt={props.mobilePayAlt}
                returnToCalculator={props.returnToCalculator}
                commission={props.paymentMethod?.commission}
                amountFrom={amountFrom}
                fromAmountIssue={fromAmountIssue}
                clickHandler={props.clickHandler}
                temporarilyUnavailableReason={temporarilyUnavailableReason}
                isTemporarilyUnavailableSource={isTemporarilyUnavailableSource}
                isInactive={true}
                isDisabled={true}
                bonusBalance={bonusBalance}
                isDisabledForOfakim={isDisabledForOfakim}
                ofakimHandleKycFlow={ofakimHandleKycFlow}
                modalRef={props.modalRef}
            />
        );
    } else {
        return (
            <EnabledPaymentMethod
                name={getPaymentMethodName(props.paymentMethod, props.category, true)}
                description={props.paymentMethod?.description}
                commission={props.paymentMethod?.commission}
                paymentMethod={props.paymentMethod}
                method={method}
                code={props.paymentMethod?.code}
                icon={props.icon}
                src={props.src}
                diskVariant={props.diskVariant}
                withoutRadius={props.withoutRadius}
                mobilePayAlt={props.mobilePayAlt}
                clickHandler={props.clickHandler}
                badge={props.badge}
                actionBanner={props.actionBanner}
                getPaymentFlow={props.getPaymentFlow}
                paymentMethodCategory={props.paymentMethodCategory}
                recipientType={props.recipientType}
                category={props.category}
                popupRef={props.popupRef}
            />
        );
    }
};

export default PaymentMethod;
